/**
 * Constants for various buffer types in Pixi
 * @category rendering
 * @advanced
 */
export enum BUFFER_TYPE
{
    /** buffer type for using as an index buffer */
    ELEMENT_ARRAY_BUFFER = 34963,
    /** buffer type for using attribute data */
    ARRAY_BUFFER = 34962,
    /** the buffer type is for uniform buffer objects */
    UNIFORM_BUFFER = 35345,
}

